module.exports = __webpack_public_path__ + "static/media/gavel.31641f8a.svg";